/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import * as Sentry from '@sentry/react';
import { withSentry } from './consts.ts';

export const initSentry = () => {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_API_POINT,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    environment: import.meta.env.VITE_API_ENDPOINT,
    integrations: [Sentry.browserTracingIntegration()],
    // tunnel: `${import.meta.env.VITE_API_ENDPOINT}/sentry-tunnel`,

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
};

export const sendSentryError = (
  error: unknown,
  captureContext?: Parameters<typeof Sentry.captureException>[1]
) => {
  if (error instanceof Error) {
    console.log(error.message);
  } else {
    console.log(error);
  }
  if (withSentry) {
    Sentry.captureException(error, captureContext);
  }
};

/*export const sendSentryMessage = (
  message: string,
  extraData?: {},
  level: string = 'info'
) => {
  console.log(message);
  // Sentry.captureMessage(message, { level, extra: extraData });
};*/

/*
export const setSentryUserContext = (userID: string): void => {
  /!*return Sentry.setUserContext({
    userID,
  });*!/
};
*/
